import React from 'react';

const ITEMS = [
  'Proof of Every Signature',
  'Built for Bharat',
  'Every Document. Every Detail.',
  'Zero Trust, Full Proof',
  'Identity Before Ink',
  'Signed, Sealed, Delivered',
  'From Send to Evidence',
  'One Platform. Complete Trust.',
  'The Last Audit Trail You\'ll Need',
];

export default function Ticker() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div className="ticker" aria-hidden="true">
      <div className="ticker-track">
        {doubled.map((item, i) => (
          <React.Fragment key={i}>
            <span className="ticker-item">{item}</span>
            <span className="ticker-item ticker-item-sep">·</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
